export default "__VITE_ASSET__39cb65cb__"